import {
  GET_SHORT_CODES,
  GET_SHORT_CODES_SUCCESS,
  GET_SHORT_CODES_ERROR,
  GET_SHORT_CODE_THREAD,
  GET_SHORT_CODE_THREAD_SUCCESS,
  GET_SHORT_CODE_THREAD_ERROR,
  MARK_SHORT_CODE_READ_SUCCESS,
  SOCKET_SHORT_CODE_MESSAGE,
} from 'src/actions/shortCodeActions';

// CON-2014 — Short codes in Connections.
// shortCodes: [{ code, latestReceivedAt, unreadCount, lastMessage }], newest first
// threads: { [code]: { messages (oldest first), nextCursor, isLoading } }
const initialState = {
  shortCodes: [],
  totalUnreadCount: 0,
  isLoaded: false,
  threads: {},
};

const sumUnread = (shortCodes) => shortCodes.reduce((sum, item) => sum + (item.unreadCount || 0), 0);

const shortCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHORT_CODES:
      return state;

    case GET_SHORT_CODES_SUCCESS: {
      const shortCodes = action.payload?.shortCodes || [];
      return {
        ...state,
        shortCodes,
        totalUnreadCount: sumUnread(shortCodes),
        isLoaded: true,
      };
    }

    case GET_SHORT_CODES_ERROR:
      return { ...state, isLoaded: true };

    case GET_SHORT_CODE_THREAD: {
      const { code } = action.payload;
      return {
        ...state,
        threads: {
          ...state.threads,
          [code]: {
            messages: [], nextCursor: null, ...state.threads[code], isLoading: true
          },
        },
      };
    }

    case GET_SHORT_CODE_THREAD_SUCCESS: {
      const { code, isOlderPage, data } = action.payload;
      const existing = state.threads[code]?.messages || [];
      const page = data?.messages || [];
      const messages = isOlderPage
        ? [...page, ...existing.filter((m) => !page.find((p) => p.id === m.id))]
        : page;
      return {
        ...state,
        threads: {
          ...state.threads,
          [code]: { messages, nextCursor: data?.nextCursor || null, isLoading: false },
        },
      };
    }

    case GET_SHORT_CODE_THREAD_ERROR: {
      const { code } = action.payload;
      return {
        ...state,
        threads: { ...state.threads, [code]: { ...state.threads[code], isLoading: false } },
      };
    }

    case MARK_SHORT_CODE_READ_SUCCESS: {
      const { code, messageIds } = action.payload;
      const readAt = new Date().toISOString();
      const thread = state.threads[code];
      const shortCodes = state.shortCodes.map((item) => (
        item.code === code
          ? { ...item, unreadCount: Math.max(0, (item.unreadCount || 0) - messageIds.length) }
          : item
      ));
      return {
        ...state,
        shortCodes,
        totalUnreadCount: sumUnread(shortCodes),
        threads: thread ? {
          ...state.threads,
          [code]: {
            ...thread,
            messages: thread.messages.map((m) => (messageIds.includes(m.id) ? { ...m, readAt } : m)),
          },
        } : state.threads,
      };
    }

    case SOCKET_SHORT_CODE_MESSAGE: {
      const { shortCode: code, message } = action.payload || {};
      if (!code || !message) return state;
      const current = state.shortCodes.find((item) => item.code === code);
      const updated = {
        code,
        latestReceivedAt: message.receivedAt,
        unreadCount: (current?.unreadCount || 0) + (message.readAt ? 0 : 1),
        lastMessage: message,
      };
      const shortCodes = [updated, ...state.shortCodes.filter((item) => item.code !== code)];
      const thread = state.threads[code];
      return {
        ...state,
        shortCodes,
        totalUnreadCount: sumUnread(shortCodes),
        threads: thread && !thread.messages.find((m) => m.id === message.id) ? {
          ...state.threads,
          [code]: { ...thread, messages: [...thread.messages, message] },
        } : state.threads,
      };
    }

    default:
      return state;
  }
};

export default shortCodeReducer;
